import { FEED_AUTH_KEY } from '@/constants';
import { LoginResponse } from '@/query';
import { getStorage } from './local-storage';
/**
 * Rastreabilidade da fazenda logada, lida direto do storage.
 *
 * Existe para o código que roda fora da árvore React (serviços de sincronização, filas em background) e por isso não
 * alcança o `useCommonLayout`. Dentro de componente, use o contexto.
 *
 * A leitura é feita a cada chamada de propósito: a flag muda quando o usuário salva a configuração da fazenda, e quem
 * chama precisa ver o valor atual, não o do início da sessão.
 */
export function hasTraceability(): boolean {
  return !!getStorage<LoginResponse>(FEED_AUTH_KEY)?.user?.farm?.hasTraceability;
}

/** Mensagem do hook de rastreabilidade do backend (`src/traceability-guard.ts`). */
const TRACEABILITY_DISABLED_MESSAGE = 'Fazenda não possui rastreabilidade ativada';

/**
 * Identifica a recusa do backend em `/announcements` e `/vegas` quando a fazenda está sem rastreabilidade. As duas
 * camadas de request (`fetch` via `fdm://` e axios) expõem `statusCode` e `message`, então a checagem serve para as
 * duas.
 */
export function isTraceabilityDisabledError(error: unknown): boolean {
  const { statusCode, message } = (error ?? {}) as { statusCode?: number; message?: string };

  return statusCode === 403 && !!message?.includes(TRACEABILITY_DISABLED_MESSAGE);
}
